export const boothPricing = {
    1: 195,
    2: 295,
    3: 595
};

export const orderOptions = {
    props: [
        {
            image: '',
            title: 'Standaard props',
            description: 'Een setje met props die voor alle evenementen geschikt is',
            price: 0,
            selected: true
        },
        {
            image: '',
            title: 'Thema props',
            description: 'Klik hier om een overzicht te krijgen van alle thema props',
            price: 15
        },
        {
            image: '',
            title: 'Props op maat',
            description: 'Laat unieke props door onze designer maken (3 stuks, max 20x20cm, 5mm forex) ',
            price: 50
        },
        {
            image: '',
            title: 'Verkleedkist',
            description: 'Een kist vol met pruiken, boa\'s, brillen en opblaasbare attributen',
            price: 30
        }
    ],
    backDrops: [

        {
            image: '',
            title: 'Witte achtergrond',
            price: 20
        },
        {
            image: '',
            title: 'Gouden achtergrond',
            price: 40
        },
        {
            image: '',
            title: 'Zilveren achtergrond',
            price: 40
        }
    ],
    templates: [
        {
            image: '',
            title: 'Standaard frame',
            price: 0,
            selected: true,
            description: 'Keuze uit 20 templates, met eigen tekst'
        },
        {
            image: '',
            title: 'Op maat gemaakt frame',
            price: 25,
            description: 'Een op maat gemaakt frame in stijl van bijvoorbeeld de uitnodiging'
        }
    ],
    expansion: [
        {
            image: '',
            title: 'Printen',
            description: 'Laat uw gasten de gemaakte collages uitprinten! 500 printjes á 10x15 cm, 1000 printjes á 5x15 cm.',
            price: 100
        },{
            image: '',
            title: 'Halen / Brengen buiten de regio',
            description: 'We brengen, installeren en halen de photobooth. De photobooth wordt aan het begin van het evenement gebracht en aan het eind van het evenement weer gehaald.',
            price: 100,
            exlcudeFromDiscount: true
        },
        // {
        //     image: '',
        //     title: 'Zelf halen / terugbrengen',
        //     description: 'Kom je zelf de photobooth halen en brengen? Je krijgt dan 15 euro korting op jouw boeking! Er wordt wel een borg in rekening gebracht.',
        //     price: -15,
        //     exlcudeFromDiscount: true
        // },
        {
            image: '',
            title: 'Website widget',
            description: 'Met de Website widget kunt u foto\'s direct tonen op een eigen website',
            price: 25
        },
        {
            image: '',
            title: 'Live upload',
            description: 'Plaats foto\'s die gemaakt zijn direct op de eigen facebook pagina',
            price: 50
        },
        {
            image: '',
            title: 'USB met foto\'s',
            description: 'Ontvang na het event alle foto\'s op een luxe usb stick',
            price: 25
        },
        {
            image: '',
            title: 'WIFI Hotspot',
            description: 'Slecht wifi bereik op de locatie? We nemen graag een eigen hotspot mee!',
            price: 0
        },
        // {
        //     image: '',
        //     title: 'Live Slideshow',
        //     description: 'Toon de gemaakte foto\'s direct op een groot scherm',
        //     price: 75
        // }
    ]
};


// WEBPACK FOOTER //
// ./src/config/options.js